// Modern browser targets already support the features from Next's legacy
// client polyfill bundle, so we can skip shipping that extra runtime chunk.
module.exports = {}
